/** Phaser's depth setter queues a full display-list sort even when the value is unchanged. */
export function setDepthIfChanged(
  obj: { depth: number; setDepth: (value: number) => unknown },
  depth: number,
): void {
  if (obj.depth !== depth) {
    obj.setDepth(depth);
  }
}
